module.exports = __webpack_public_path__ + "static/media/arrows.363e56d5.svg";